module.exports = __webpack_public_path__ + "static/img/sale_back.27eb68f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/sale_back.jpg?20181011
// module id = gRQe
// module chunks = 1